import React, {Suspense} from 'react';
import {Redirect, Switch} from 'react-router-dom';
import {withRouter, Route} from 'react-router';
import LandingAsync from './pages/ycp/landing/async';
import PrizeAsync from './pages/ycp/prize/async';
import JoinAsync from './pages/ycp/join/async';
import ReviewAsync from './pages/ycp/review/async';
import SignInAsync from './pages/ycp/login/async';
import GalleryAsync from './pages/ycp/gallery/async';
import WinnerAsync from './pages/ycp/winner/async';
import DefaultLayout from './components/layout/defaultlayout/index';

export default withRouter(({component: Component, location, ...rest}) => {
  return (
    <Suspense fallback={<div />}>
      <DefaultLayout>
        <Switch location={location}>
          <Redirect
            exact
            from="/"
            to={'/2021perfectstickercontest/landing' + location.search}
          />
          <Redirect
            exact
            from="/2021perfectstickercontest"
            to={'/2021perfectstickercontest/landing' + location.search}
          />
          <Route
            from="/2021perfectstickercontest/landing"
            to="/2021perfectstickercontest/landing"
            exact
            component={LandingAsync}
          />
          <Route
            from="/2021perfectstickercontest/prize"
            to="/2021perfectstickercontest/prize"
            exact
            component={PrizeAsync}
          />
          <Route
            from="/2021perfectstickercontest/join"
            to="/2021perfectstickercontest/join"
            exact
            component={JoinAsync}
          />
          <Route
            from="/2021perfectstickercontest/gallery"
            to="/2021perfectstickercontest/gallery"
            exact
            component={GalleryAsync}
          />
          <Route
            from="/2021perfectstickercontest/review/list"
            to="/2021perfectstickercontest/review/list"
            exact
            component={ReviewAsync}
          />
          <Route
            from="/2021perfectstickercontest/login"
            to="/2021perfectstickercontest/login"
            exact
            component={SignInAsync}
          />
          <Route
            from="/2021perfectstickercontest/winner"
            to="/2021perfectstickercontest/winner"
            exact
            component={WinnerAsync}
          />
        </Switch>
      </DefaultLayout>
    </Suspense>
  );
});
